import React, { ComponentProps, FC, ReactElement } from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import CompensationSubmission from 'buyside/components/presentation/CompensationSubmissionPage/compensationSubmission';

const CompensationSubmissionPageRoot: FC<ComponentProps<typeof CompensationSubmission>> = ({
  actualId,
  estimatedId
}): ReactElement => {
  return (
    <ErrorBoundary pageName="compensation submission">
      <CompensationSubmission actualId={actualId} estimatedId={estimatedId} />
    </ErrorBoundary>
  );
};

export default CompensationSubmissionPageRoot;
